import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ITRActions } from '../../Actions';
import { base64Logic } from "../../Shared/common_logic";
import Loader from '../../Components/Loader/Loader';
import './ITR.css'
class ITR extends Component {

    state = {
        password: "",
        passwordType: 'password',
        errors: {},
        payload: null,
        showITR: true
    }

    componentWillMount() {
        const { history } = this.props;
        let base64_decode;
        let errors = {};
        
        let params = new URLSearchParams(history.location.search);
        let payload = params.get('payload');

        if (payload) {
            base64_decode = base64Logic(payload, "decode");
            errors['payload_missing'] = "";
        } else {
            errors['payload_missing'] = "Payload Missing";
        }

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ errors })
        }
        this.setState({ payload: base64_decode })
    }

    initialPage = () => {
        window.location = window.location.href
    }

    submitITRDetails = () => {
        const { payload, password } = this.state;
        let errors = {};

        if (payload.pan === undefined || payload.pan.length === 0) {
            errors['pan'] = 'Require Pan';
        } else {
            errors['pan'] = '';
        }

        if (payload.app_id === undefined || payload.app_id.length === 0) {
            errors['app_id'] = 'Require App ID';
        } else {
            errors['app_id'] = '';
        }

        if (password.length === 0) {
            errors['password'] = 'Require Password';
        } else {
            errors['password'] = '';
        }

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ errors })
            return
        }
        if (payload && payload.pan.length && password.length) {
            this.props.postITRDocuments({
                app_id: payload.app_id,
                username: payload.pan,
                password,
                loan_application_id: payload.loan_application_id
            })
            this.setState({ showITR: false, errors: {} })
        }
    }

    passwordView = () => {
        var newPass = this.state.passwordType === "password" ? "text" : "password";
        this.setState({passwordType: newPass});
    }

    render() {
        const { Itr } = this.props;
        const itrPostError = Itr && Itr.postError;
        const { errors, payload, password, showITR } = this.state;
        const checkItrSuccess = Itr && Itr.postResult && Itr.postResult.data && Itr.postResult.data.status;
        const checkItrSuccessMsg = Itr && Itr.postResult && Itr.postResult.data && Itr.postResult.data.message;
        const isEmpty = Object.keys(errors).length === 0;
        return (
            <div className="container-fluid padd0 container-ffluid">
                <div className="row container-ffluid-row">
                {
                    Itr.postloading &&  <div className="col-md-12 paddingZZero"><Loader textLoading={true} /></div>
                }
                {
                    (showITR || itrPostError) &&
                        <>
                            <div className="col-md-12 d-flex pl-5">
                                <div className="col-md-6 p-0">
                                    <img src="https://mintifi.com/media/logo.png" alt="logo" className="pt-4 mb-4" />
                                </div>
                            </div>
                            <div className="col-md-12 paddingZZero">
                                <div>
                                    <div className="text-center">
                                        <span><span className="heading itrColor">ITR </span><label className="heading">Details Submission</label></span>
                                    </div>
                                    <div className="text-content">
                                        <p className="mb-0">You are about the submit ITR details of your business with Mintifi Private Limited.</p>
                                        <p className="mb-0">Your data is protected with the highest standards and will be shared across </p>
                                        <p>lenders associated with your loan application <strong className="text-id">{payload && payload.loan_application_id}</strong></p>
                                    </div>
                                </div>
                                {isEmpty === false ?
                                <>
                                {errors && Object.keys(errors) && Object.keys(errors).map(err => {
                                    return (
                                        <div style={{ textAlign: 'center' }}>
                                            {
                                                errors[err].length > 0 ?
                                                    <div key={`mintifi_${err}`}>
                                                        <span className="col-md-4 m-auto" style={{ color: "crimson", font: 'normal 16px Lato' }}>
                                                            {errors[err]}
                                                        </span>
                                                    </div> : null
                                            }
                                        </div>
                                    )
                                })}
                                </>
                                :
                                <>
                                {Itr.postError && Itr.postError.error !== undefined ?
                                    <div style={{ textAlign: 'center' }}>
                                        <span style={{ color: "crimson", fontSize: "16px",textAlign: 'center' }}>
                                            {Itr.postError.error.data.message}
                                        </span>
                                    </div> : null
                                }
                                {Itr.postError && Itr.postError.data !== undefined ?
                                   <div style={{ textAlign: 'center' }}>
                                        <div  style={{ color: "crimson", fontSize: "16px",textAlign: 'center' }}>
                                            {Itr.postError.data.message}
                                        </div>
                                    </div>
                                : null
                                }
                                </>
                            }
                                    <div className="mrgn80">
                                        <div className="col-md-3 m-auto paddingZZero">
                                            <p className="mb-0 labelText mb-2">PAN<span className="red">*</span></p>
                                            <input type="text" placeholder="CEAPR1448M" readOnly value={payload && payload.pan} className="col-md-12 panInput" />
                                        </div>
                                        <div className="col-md-3 m-auto paddingZZero">
                                            <p className="mb-0 mt-4 labelText mb-2">PASSWORD<span className="red">*</span></p>
                                            <div className="d-flex">
                                                <div className="col-md-12 p-0 FlexNone">
                                                    <input type={this.state.passwordType} placeholder="Enter password" onChange={event => this.setState({ password: event.target.value })} value={password} className="col-md-12 passInput" />
                                                </div>
                                                <div onClick={() => this.passwordView()} className="eyeIcon">
                                                    {this.state.passwordType === "password" ?
                                                    <img src="/images/eyes_unvisibleicon.png" alt="ey" />
                                                    :
                                                    <img src="/images/eyes_visibleicon.png" alt="ey" />
                                                    }
                                                </div>
                                            </div>
                                            <span> <img src="/images/info.png" alt="ey" className="mr-1" /><span className="password-text-rules">Enter your password as per </span><a href="https://www.incometaxindiaefiling.gov.in/home" className="password-link-rules">https://www.incometaxindiaefiling.gov.in/home</a></span>
                                        </div>
                                    </div>
                            </div>
                            <div className="col-md-12 mt-3 d-flex sub-btn-itr">
                                <div className="col-md-3 m-auto">
                                   <div class="col-md-12">
                                     <button type="button" className="btnSubmit float-right" onClick={() => this.submitITRDetails()}>Submit <img src="/images/arrow.png" alt="icon" className="ml-3 mb-1 dispNone" /></button>
                                   </div>
                                </div>
                            </div>
                </> 
                }
                {
                    (checkItrSuccess === "success" && showITR === false && Itr.postloading === false) ?
                        <>
                            <div className="col-md-12 mrgn52 paddingZZero">
                                <div>
                                    <h2 className="thankyou-main-text">Thank You!</h2>
                                    <p className="thankyou-inner-text">{checkItrSuccessMsg}</p>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div className="text-center">
                                        <img src="/images/message popup.png" alt="message" className="imgWidth" style={{ height: 253 }} />
                                    </div>
                                </div>
                            </div>
                        </> : null
                }
                </div>
            </div>
        )
    }
}

function mapState(state) {
    const { Itr } = state;
    return { Itr };
}

const actionCreators = {
    postITRDocuments: ITRActions.postITRDocuments
};

export default connect(mapState, actionCreators)(ITR);